<template>
  <div id="WorkReport">
    <van-notice-bar
      color="#1989fa"
      background="#ecf9ff"
      left-icon="info-o"
      mode="closeable"
    >
      {{ getAddr().RangeName }} ({{ getAddr().RoleName }})
      需上报工作任务列表,请核对工作任务时间和要求,及时上报.
    </van-notice-bar>
    <div
      class="count-down"
      v-if="timeIf"
      @click="
        $toast('最近的工作任务,将在' + timeShow + '后开始，将自动刷新任务列表')
      "
    >
      <i class="fa fa-refresh">
        <small>列表{{ timeShow }}自动刷新</small>
      </i>
    </div>
    <div class>
      <div class="m-2 border-radius">
        <van-tabs
          v-model="active"
          color="rgb(9, 126, 212)"
          :line-width="135"
          :line-height="3"
        >
          <van-tab title="我的任务">
            <van-pull-refresh
              v-model="isLoading"
              @refresh="onRefresh"
              style="height: 100%"
            >
              <div class="text-left">
                <!-- 切换状态 -->
                <div class="side-nav">
                  <div class="mobile-switch-lang">
                    <span :class="!isAll ? 'active' : ''" @click="isAll = false"
                      >待上报</span
                    >
                    <span :class="isAll ? 'active' : ''" @click="isAll = true"
                      >全部</span
                    >
                  </div>
                  <h5 class="vant-title">
                    <span>
                      {{ isAll ? "全部任务" : "待上报任务" }}
                      <b>{{ "(" + workProcessList.length + ")" }}</b>
                    </span>
                  </h5>
                </div>
                <!-- 工作任务列表 -->
                <div class="card" v-if="workProcessList < 1">
                  <div class="intro">
                    <!-- <img id="logo" src="../assets/logo.png" /> -->
                    <i class="fa fa-coffee fa-3x color-gray"></i>
                    <!-- <h2>标题</h2> -->
                    <p>{{ isAll ? "没有工作任务" : "没有待上报工作" }}</p>
                  </div>
                </div>
                <template v-for="(item, index) in workProcessList">
                  <van-swipe-cell
                    v-if="
                      !underway ||
                      new Date(item.BeginTime).valueOf() < new Date().valueOf()
                    "
                    :key="index"
                    class="mt-2 border-radius"
                  >
                    <van-cell :border="false">
                      <template slot="icon">
                        <i
                          class="fa fa-fw mt-1 mr-2"
                          :class="
                            item.ProcessStatus == 1
                              ? 'fa-check-circle-o color-green'
                              : 'fa-circle-o-notch'
                          "
                        ></i>
                      </template>
                      <template slot="title">
                        <div>
                          <span
                            @click="
                              setWorkProcessBtn(
                                item.SplitProcessID,
                                item.PlugID
                              )
                            "
                            class="text-bold"
                            :class="item.AllowReport ? '' : 'color-gray'"
                            >{{ item.ProcessName }}</span
                          >
                          <van-icon
                            class="ml-1 mr-1"
                            name="question-o"
                            @click="$toast(item.Memo)"
                          />
                          <van-tag
                            class="ml-1 mb-1"
                            size="medium"
                            mark
                            type="warning"
                            >{{ item.ProcessTypeName }}</van-tag
                          >
                          <van-tag
                            class="ml-1 mb-1"
                            size="medium"
                            plain
                            round
                            type="warning"
                            v-if="
                              item.ProcessStatus != 0 && item.ProcessStatus != 1
                            "
                            >{{ item.ProcessStatusText }}</van-tag
                          >
                          <van-tag
                            class="ml-1 mb-1"
                            hairline
                            plain
                            round
                            v-if="item.AssignUserList.length > 0"
                            @click="scanSubStatusUser(item)"
                          >
                            指派{{ item.AssignUserList[0].RealName }}
                            {{
                              item.AssignUserList.length > 1
                                ? "...(" + item.AssignUserList.length + "人)"
                                : ""
                            }}
                          </van-tag>
                          <van-tag
                            class="ml-1 mb-1"
                            hairline
                            plain
                            round
                            size="primary"
                            type="info"
                            @click="StatusAssignBtn(item)"
                            v-else-if="
                              item.ProcessStatus != 1 &&
                              getWork().IsFinally == 1
                            "
                            >可指派</van-tag
                          >
                        </div>
                      </template>
                      <template slot="label">
                        <!-- <span
                        class="mr-2"
                        @click="setWorkProcessBtn(item.SplitProcessID, item.PlugID)"
                      >{{ item.Memo }}</span>
                        <br />-->
                        <span
                          class="mr-2"
                          v-if="item.BeginTime && item.EndTime"
                          @click="
                            setWorkProcessBtn(item.SplitProcessID, item.PlugID)
                          "
                        >
                          {{
                            "上报时间 " +
                            formatShortDateTime(item.BeginTime) +
                            " - " +
                            formatShortDateTime(item.EndTime)
                          }}
                        </span>
                      </template>
                    </van-cell>
                    <template
                      slot="right"
                      v-if="
                        item.AssignUserList.length < 1 &&
                        item.ProcessStatus != 1
                      "
                    >
                      <van-button
                        square
                        type="info"
                        text="快速指派"
                        class="h-100"
                        v-if="
                          item.ProcessStatus != 1 && getWork().IsFinally == 1
                        "
                        @click="StatusAssignBtn(item)"
                      />
                    </template>
                  </van-swipe-cell>
                </template>
                <div
                  class="mt-4 mb-4 w-100 text-center"
                  v-if="workProcessList.length > 1"
                >
                  <van-tag
                    round
                    class="pl-4 pr-4"
                    v-if="!isAll && underway"
                    @click="underway = !underway"
                  >
                    <small>加载全部待上报工作任务</small>
                    <van-icon name="arrow-down" class="ml-2" />
                  </van-tag>
                </div>
                <div class="text-right color-gray m-3">
                  <small>
                    <i class="fa fa-fw fa-refresh"></i>
                    <small>刷新时间</small>
                    {{ new Date().getHours() + ":" + new Date().getMinutes() }}
                  </small>
                </div>
              </div>
            </van-pull-refresh>
          </van-tab>
          <van-tab title="我发起的任务">
            <div class="text-left color-gray">
              <!-- 我发起的任务列表 -->
              <div class="m-4 text-center" v-if="!(subdata.length > 0)">
                <p>本次考试工作中还没有发起工作任务</p>
                <small
                  >*通过工作任务分解发起的任务，可以在这里查看整体完成情况.</small
                >
              </div>
              <template v-for="(item, index) in subdata">
                <van-cell
                  icon="bars"
                  :border="false"
                  :key="index"
                  class="mt-2 border-radius"
                >
                  <template slot="title">
                    <div>
                      <b>{{ item.ProcessName }}</b>
                      <van-tag
                        class="ml-1 mb-1"
                        size="medium"
                        mark
                        type="warning"
                        >{{ item.ProcessTypeName || "任务线" }}</van-tag
                      >
                      <van-tag
                        class="ml-1 mb-1"
                        size="medium"
                        round
                        plain
                        @click="
                          setWorkProcessBtn(
                            item.ParentSplitProcessID,
                            item.PlugID
                          )
                        "
                        >{{ item.ParentSplitProcessName }}</van-tag
                      >
                    </div>
                  </template>
                  <template slot="label">
                    <!-- 工作任务备注及上报时间提示 -->
                    <div class="color-blue">
                      <van-row>
                        <van-col span="1">
                          <van-icon name="info-o" />
                        </van-col>
                        <van-col span="23">
                          {{ item.Memo }}.{{
                            "上报时间 " +
                            formatShortDateTime(item.BeginTime) +
                            " 至 " +
                            formatShortDateTime(item.EndTime)
                          }}
                        </van-col>
                      </van-row>
                    </div>
                    <!-- <van-notice-bar
                    text="通知内容"
                    left-icon="info-o"
                    background="#ffffff"
                    color="#1989fa"
                  >
                    <template
                      slot="default"
                    ></template>
                    </van-notice-bar>-->
                    <!-- 工作任务分解对象列表 -->
                    <div
                      v-for="(e, i) in item.SplitProcess"
                      :key="i"
                      class="ml-4 p-1"
                    >
                      <div>
                        <van-icon
                          class="mt-1 mr-1"
                          :name="
                            e.ProcessStatus == 1
                              ? 'certificate color-green'
                              : 'circle'
                          "
                        ></van-icon>
                        <small class="color-black">{{ e.OrganName }}</small>
                        <i
                          v-if="e.ProcessStatus != 1"
                          class="fa fa-fw fa-volume-up color-red ml-1"
                          @click="pushBtn(e.SplitProcessID)"
                        ></i>
                      </div>
                      <div>
                        <div
                          class="mt-1 ml-4 w-100"
                          v-for="(sub_e, sub_i) in e.UserList"
                          :key="sub_i"
                        >
                          <i
                            class="fa fa-fw"
                            :class="
                              sub_e.Status == 1
                                ? 'fa-check-square-o'
                                : 'fa-minus'
                            "
                          ></i>
                          <template v-if="sub_e.UserID">
                            {{ sub_e.RoleName + "-" + sub_e.RealName }}
                            <i class="fa fa-fw fa-phone color-blue"></i>
                            <a
                              class="color-blue"
                              :href="'tel:' + sub_e.Phone"
                              >{{ sub_e.Phone }}</a
                            >
                          </template>
                          <template v-else>{{ sub_e.RoleName }}</template>
                        </div>
                      </div>
                    </div>
                  </template>
                </van-cell>
              </template>
            </div>
          </van-tab>
        </van-tabs>
      </div>
    </div>
    <!--设置工作任务指派窗口-->
    <van-popup
      id="sheet1"
      position="bottom"
      class="popup-l2"
      v-model="sheet1"
      closeable
    >
      <van-nav-bar title="工作任务指派" />
      <div class="mt-1 p-2">
        <van-divider>{{ currprocess.ProcessName }}</van-divider>
        <div>
          <el-form>
            <el-form-item>
              <el-select
                v-model="sheet1Content.option"
                multiple
                placeholder="请选择工作人员"
                style="width: 90%"
              >
                <el-option
                  v-for="(item, index) in sheet1Content.contactsList"
                  :key="index"
                  :label="item.RealName"
                  :value="item.UserID"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div class="m-4">
          <van-button
            @click="addSubStatusBtn"
            round
            hairline
            type="info"
            class="w-100"
            >提交</van-button
          >
        </div>
      </div>
    </van-popup>
    <!-- 查看工作任务指派详细信息 -->
    <van-popup
      id="sheet2"
      position="bottom"
      class="popup-l2"
      v-model="sheet2"
      closeable
    >
      <van-nav-bar title="已指派工作人员" />
      <div class="m-4">
        {{ substatususer }}
        <van-divider
          >当前工作已指派以下{{ substatususer.length }}名工作人员</van-divider
        >
        <van-cell-group>
          <van-cell
            v-for="(item, index) in substatususer"
            :key="index"
            class="pl-4 pb-4 text-left"
          >
            <template slot="title">
              <!-- <i class="fa fa-fw fa-user"></i> -->
              <b class="pr-4">{{ item.RealName }}</b>
              <i class="fa fa-fw fa-phone color-blue" v-if="false"></i>
            </template>
            <template slot="default">
              <small>{{ item.RoleName }}</small>
            </template>
            <template slot="label">
              <template v-if="item.Phone">
                <p>
                  <small>电话</small>
                  <i class="fa fa-fw fa-phone color-blue"></i>
                  <a class="color-blue" :href="'tel:' + item.Phone">
                    {{ item.Phone }}
                  </a>
                </p>
              </template>
              <template v-else>
                <small>没有预留联系方式</small>
              </template>
            </template>
            <template slot="icon">
              <van-icon name="contact" class="p-1" />
            </template>
            <template slot="right-icon">
              <van-icon
                name="delete"
                class="p-1 ml-2 color-red"
                @click="deleteSubStatusBtn(item.UserID)"
              />
            </template>
          </van-cell>
        </van-cell-group>
      </div>
    </van-popup>
    <!-- 加载数据时显示遮罩层 -->
    <van-overlay :show="overlayshow">
      <div class="wrapper">
        <van-loading vertical>工作任务加载中...</van-loading>
      </div>
    </van-overlay>
  </div>
</template>
<script>
export default {
  name: "WorkReport",
  data () {
    return {
      loop: 0,
      active: 0,
      isLoading: false, // 刷新状态
      workProcessList: [], // 绘制工作列表
      overlayshow: true, // 遮罩层
      subdata: [], // 我发起的工作任务列表
      isAll: false, // 全部工作任务与待上报工作任务切换
      underway: true, //正在进行
      sheet1: false, // 分解窗口
      sheet1Content: {
        option: [], // 指派分解任务操作员
        contactsList: [] // 工作环节指派时获取同一机构联系人列表
      },
      sheet2: false, // 指派详情
      currprocess: {}, // 工作任务分解对象,每次弹出分解对话框刷新
      substatususer: [], // 查看任务指派工作人员列表
      timeOut: [],
      timer: null,
      timeCsd: "",
      timeShow: "",
      timeIf: false,
      timePushShow: false
    };
  },
  watch: {
    // eslint-disable-next-line
    isAll: function (newVal, oldVal) {
      this.drawProcessList(newVal);
    }
  },
  methods: {
    onRefresh () {
      setTimeout(() => {
        /* this.$toast("刷新成功"); */
        this.isLoading = false;
        this.drawProcessList();
      }, 500);
    },
    drawProcessList: function () {
      this.overlayshow = true; // 显示遮罩层
      //获取考试工作任务列表
      this.apiWorkProcessListGet(
        {
          WorkID: this.getWork().WorkID,
          OrganID: this.getAddr().OrganID,
          RoleID: this.getAddr().RoleID,
          RangeID: this.getAddr().RangeID
          /* RoleTypeID: this.getWork().user.RoleTypeID */
        },
        this,
        res => {
          if (res.code == 20000) {
            this.overlayshow = false; //获取工作任务后隐藏加载提示遮罩层
            //循环数据接口返回的工作任务,根据当前显示条件插入待上报/全部(isAll || item.ProcessStatus != 1)工作任务
            this.workProcessList = [];
            for (let index = 0; index < res.data.length; index++) {
              let element = res.data[index]
              //移动端是否显示
              if (element.IsMobileFlg == 1) {
                //根据待上报/全部显示条件进行过滤
                if (this.isAll || element.ProcessStatus != 1) {
                  // 如果工作任务是子任务，进行判断处理
                  if (element.ParentProcessID != "") {
                    // 声明主任务是否存在验证
                    var verifyMainTaskExists = false;
                    // 再次循环工作任务列表
                    for (let i = 0; i < res.data.length; i++) {
                      let element2 = res.data[i]
                      // 判断子任务的ParentProcessID有对应的主任务ProcessID
                      if (element2.ProcessID == element.ParentProcessID) {
                        // 设置验证结果-主任务存在
                        verifyMainTaskExists = true;
                      }
                    };
                    if (verifyMainTaskExists) {
                      // 如果主任务存在，当前工作列表不添加主任务
                    } else {
                      this.workProcessList.push(element);
                    }
                  } else {
                    this.workProcessList.push(element);
                  }
                }
                //将当前工作任务结束时间添加到工作任务结束时间列表
                if (element.AllowReport == false) {
                  this.timeOut.push(element.BeginTime);
                }
              }
            };
            // this.timeCsd = this.timeOut[0].BeginTime;
            // console.log(this.timeOut);
            let qwe = {};
            //循环工作任务结束事件列表
            this.timeOut.forEach((element, index) => {
              let dateBegin = new Date(element.replace(/-/g, "/")); //将-转化为/，使用new Date
              // qwe.push(dateBegin.getTime())
              qwe[index] = dateBegin.getTime();
              this.timeCsd = Math.max(qwe[index]);
            });
            //this.workProcessList = res.data;
            this.timehandle();
          } else {
            this.$toast(res.message);
          }
        }
      );
    },
    // 计算定时器
    timehandle () { },
    // 计算时间差
    timeFn (d1) {
      // let dateBegin = new Date(d1.replace(/-/g, "/")); //将-转化为/，使用new Date
      // console.log(dateBegin.getTime());
      let dateEnd = new Date(); //获取当前时间
      let dateDay = dateEnd.getDate(); //获取日
      let dateToDayDiff = new Date(this.timeCsd); // 最近的任务时间
      let dateToDay = dateToDayDiff.getDate(); //最近的任务日
      let dateDiff = d1 - dateEnd.getTime(); //时间差的毫秒数
      //let dayDiff = Math.floor(dateDiff / (24 * 3600 * 1000)); //计算出相差天数
      let leave1 = dateDiff % (24 * 3600 * 1000); //计算天数后剩余的毫秒数
      let hours = Math.floor(leave1 / (3600 * 1000)); //计算出小时数
      //计算相差分钟数
      let leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数
      let minutes = Math.floor(leave2 / (60 * 1000)); //计算相差分钟数
      //计算相差秒数
      // let leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数
      // let seconds = Math.round(leave3 / 1000);
      let timeSec =
        // " 相差 " +
        // dayDiff +
        // "天 " +
        // hours + "小时 " +
        minutes + " 分钟";
      // +
      // seconds +
      // " 秒";
      //dateDiff小于零时且当前日不等于最近任务日时候 隐藏倒计时
      if (dateDiff < 0 && dateDay != dateToDay) {
        this.timeIf = false;
      }
      //dateDiff大于零时且当前日等于最近任务日时候 显示倒计时
      if (dateDiff > 0 && dateDay == dateToDay && hours < 1) {
        this.timeIf = true;
      }
      // 当dateDiff归零时  刷新任务列表
      if (dateDiff == 0) {
        this.drawProcessList();
      }
      // if (dateEnd.setHours(0, 0, 0, 0) == todaysDate.setHours(0, 0, 0, 0)) {
      //   return true;
      // }

      // console.log('123');
      // console.log("明天是：" + this.showdate(1));

      // console.log(
      //   dateDiff + "时间差的毫秒数",
      //   dayDiff + "计算出相差天数",
      //   leave1 + "计算天数后剩余的毫秒数",
      //   hours + "计算出小时数",
      //   minutes + "计算相差分钟数",
      //   seconds + "计算相差秒数"
      // );
      return timeSec;
    },
    getYMDHMS (time) {
      var year = time.getFullYear(),
        month = time.getMonth() + 1,
        date = time.getDate(),
        hours = time.getHours(),
        minute = time.getMinutes(),
        second = time.getSeconds();

      if (month < 10) {
        month = "0" + month;
      }
      if (date < 10) {
        date = "0" + date;
      }
      if (hours < 10) {
        hours = "0" + hours;
      }
      if (minute < 10) {
        minute = "0" + minute;
      }
      if (second < 10) {
        second = "0" + second;
      }

      return {
        year: year,
        month: month,
        date: date,
        hours: hours,
        minute: minute,
        second: second
      }; //不想要对象的情况下 直接返回 //return year+'年'+ month+'月'+date+'日'+hours+':'+minute+':'+second
    },
    drawSplitProcessList: function () {
      this.apiUserSplitProcessListGet(
        {
          WorkID: this.getWork().WorkID,
          OrganID: this.getAddr().OrganID,
          RoleID: this.getAddr().RoleID
        },
        this,
        res => {
          this.subdata = res.data;
        }
      );
    },
    /* 考务环节选择 */
    setWorkProcessBtn: function (SplitProcessID, PlugID) {
      //判断考务环节
      this.apiWorkProcessVerifyGet(
        {
          WorkID: this.getWork().WorkID,
          SplitProcessID: SplitProcessID
        },
        this,
        res => {
          if (res.code == 20000) {
            this.setProcess(PlugID)
            this.$router.push({
              name: "Process",
              params: { id: SplitProcessID, PlugID: PlugID }
            });
          } else {
            this.$toast(res.message);
          }
        }
      );
    },
    /* 工作任务指派设置 */
    StatusAssignBtn (item) {
      this.currprocess = item;
      if (item.ProcessStatus == 1) {
        this.$toast("工作任务已上报完成.");
        return;
      }
      /* 弹出分解任务对话框 */
      this.sheet1 = true;
      this.sheet1Content.option = [];
    },
    /* 工作任务指派操作 */
    addSubStatusBtn () {
      //判断是否选择了工作人员
      if (this.sheet1Content.option.length < 1) {
        this.$toast("未选择工作人员");
        return;
      }
      this.$dialog
        .confirm({
          title: "提示",
          message: "确定执行工作任务指派 ?"
        })
        .then(() => {
          // on confirm
          this.apiWorkProcessPost(
            {
              Type: 0,
              WorkID: this.getWork().WorkID,
              OrganID: this.getAddr().OrganID,
              RoleID: this.getAddr().RoleID,
              SplitProcessID: this.currprocess.SplitProcessID,
              UserList: this.sheet1Content.option
            },
            this,
            res => {
              this.$toast(res.message);
              if (res.code == 20000) {
                this.drawProcessList();
                this.sheet1 = false;
              }
            }
          );
        });
    },
    scanSubStatusUser (item) {
      this.sheet2 = true;
      this.substatususer = item.AssignUserList;
      this.currprocess = item;
    },
    deleteSubStatusBtn (UserID) {
      this.$dialog
        .confirm({
          title: "提示",
          message: "删除这项指派工作任务 ?"
        })
        .then(() => {
          this.$toast("删除");
          this.apiWorkProcessDelete(
            {
              WorkID: this.getWork().WorkID,
              SplitProcessID: this.currprocess.SplitProcessID,
              UserID: UserID
            },
            this,
            e => {
              this.$toast(e.message);
              if (e.code == 20000) {
                this.drawProcessList();
                this.sheet2 = false;
              }
            }
          );
        })
        .catch(() => {
          //eslint-disable-next-line
          /* console.log("取消删除"); */
        });
    },
    pushBtn (SplitProcessID) {
      //消息推送-提醒上报工作任务
      this.$dialog
        .confirm({
          title: "提示",
          message: "发送工作任务上报提醒通知给工作人员 ?"
        })
        .then(() => {
          // on confirm
          //eslint-disable-next-line
          /* console.log("消息提醒", this.sheet1Content); */
          this.apiPushPost(
            {
              WorkID: this.getWork().WorkID,
              PushType: "splitreport",
              SplitProcessID: SplitProcessID
            },
            this,
            res => {
              //eslint-disable-next-line
              if (res.code == 20000) {
                this.$toast(res.message);
              } else {
                this.$dialog.alert({ message: res.message });
              }
            }
          );
        })
        .catch(() => {
          // on cancel
        });
    }
  },
  beforeDestroy () {
    clearInterval(this.timer);
    this.timer = null;
  },
  created () {
    if (this.getWork()) {
      this.drawProcessList();
      this.drawSplitProcessList();
      //获取工作任务分解可选机构联系人信息
      this.apiOrganRoleUserGet(
        { WorkID: this.getWork().WorkID, OrganID: this.getAddr().OrganID },
        this,
        e => {
          this.sheet1Content.contactsList = e.data.SelfLevel; //获取同一机构联系人
        }
      );
    } else {
      this.$toast("需要选择考试工作任务");
      this.$router.push({ name: "ExamManage" });
    }
    this.timer = setInterval(() => {
      // 某些定时器操作
      this.timeShow = this.timeFn(this.timeCsd);
    }, 1000);
    this.$once("hook:beforeDestroy", () => {
      clearInterval(this.timer);
    });
    // 通过$once来监听定时器，在beforeDestroy钩子可以被清除。
    this.timehandle();
  },
  mounted () { }
};
</script>

<style scoped>
#WorkReport {
  background: #efefef;
  min-height: 700px;
}
/* 工作任务状态提示样式 */
.side-nav {
  margin: 0.5rem 0;
  padding: 13px 0px;
  /* border-radius: 5px; */
  background: #ffffff;
}
.side-nav .vant-title {
  margin: 0 0 0 2px;
}
.side-nav .vant-title,
.side-nav .vant-desc {
  padding-left: 16px;
  font-weight: normal;
  -webkit-user-select: none;
  user-select: none;
}
.side-nav .vant-desc {
  margin: 0 0 15px;
  color: #7d7e80;
  font-size: 14px;
}
.side-nav .vant-title,
.side-nav .vant-desc {
  padding-left: 16px;
  font-weight: normal;
  -webkit-user-select: none;
  user-select: none;
}
/* 工作任务状态切换按钮样式 */
.mobile-switch-lang {
  position: absolute;
  top: 12px;
  right: 13px;
  overflow: hidden;
  color: #1989fa;
  font-size: 12px;
  cursor: pointer;
}
.mobile-switch-lang span.active {
  color: #fff;
  background-color: #1989fa;
  border-color: #1989fa;
}
.mobile-switch-lang span:first-child {
  border-right: none;
  border-radius: 3px 0 0 3px;
}
.mobile-switch-lang span {
  display: inline-block;
  width: 48px;
  color: #323233;
  line-height: 22px;
  text-align: center;
  background-color: #fff;
  border: 1px solid #ebedf0;
}
.count-down {
  position: fixed;
  bottom: 3.5rem;
  left: 10%;
  z-index: 99;
  background: #7d7e80;
  color: #fff;
  padding: 3px;
  margin: 5px;
  opacity: 0.7;
  border-radius: 5px;
}
</style>